import React from 'react'

export const Generic = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" y="0.75" width="26.5" height="26.5" rx="13.25" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.491 14.6248L7.6654 19.4504L8.54929 20.3343L13.3748 15.5087L13.3748 22.3332H14.6248V15.5087L19.4505 20.3343L20.3344 19.4505L15.5088 14.6248H22.3332V13.3748H15.5087L20.3344 8.54919L19.4505 7.6653L14.6248 12.491V5.6665H13.3748L13.3748 12.4909L8.54928 7.66534L7.6654 8.54922L12.491 13.3748H5.6665V14.6248H12.491Z"
      fill="black"
    />
    <rect x="0.75" y="0.75" width="26.5" height="26.5" rx="13.25" stroke="black" strokeWidth="1.5" />
  </svg>
)
